import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { Plus, Search } from 'lucide-react';
import PageHeader from './PageHeader';
import Button from '../Button';
import { ResourcePageStyled } from './ui.styles';

export default function ResourceGridPage({
  title,
  subtitle,
  createLabel,
  createPath,
  onCreate,
  searchPlaceholder = 'Search by name',
  items = [],
  loading = false,
  getItemName = item => item.name || item.agent_name || item.title || '',
  getItemDescription = item => item.description || item.desc || '',
  mineContent,
  discoverContent,
  showDiscover = true,
  mineTabLabel,
  discoverTabLabel = 'Discover',
  emptyMessage,
}) {
  const [tab, setTab] = useState('mine');
  const [query, setQuery] = useState('');

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return items;
    return items.filter(item => {
      const name = getItemName(item)?.toLowerCase?.() || '';
      const desc = getItemDescription(item)?.toLowerCase?.() || '';
      return name.includes(q) || desc.includes(q);
    });
  }, [items, query, getItemName, getItemDescription]);

  const createButton =
    createLabel &&
    (createPath ? (
      <Link to={createPath}>
        <Button width="auto">
          <Plus size={16} /> {createLabel}
        </Button>
      </Link>
    ) : (
      <Button type="button" width="auto" onClick={onCreate}>
        <Plus size={16} /> {createLabel}
      </Button>
    ));

  return (
    <ResourcePageStyled>
      <PageHeader title={title} subtitle={subtitle} actions={createButton} />

      <div className="toolbar">
        {showDiscover ? (
          <div className="tabs">
            <button type="button" className={`tab ${tab === 'mine' ? 'active' : ''}`} onClick={() => setTab('mine')}>
              {mineTabLabel || `My ${title}`}
            </button>
            <button
              type="button"
              className={`tab ${tab === 'discover' ? 'active' : ''}`}
              onClick={() => setTab('discover')}>
              {discoverTabLabel}
            </button>
          </div>
        ) : (
          <div />
        )}

        <div className="search">
          <Search size={16} />
          <input value={query} onChange={e => setQuery(e.target.value)} placeholder={searchPlaceholder} />
        </div>
      </div>

      {tab === 'discover' && showDiscover ? (
        typeof discoverContent === 'function' ? (
          discoverContent(query)
        ) : (
          discoverContent
        )
      ) : loading ? (
        <div className="grid">
          {Array.from({ length: 8 }).map((_, i) => (
            <div key={i} className="skeleton" />
          ))}
        </div>
      ) : filtered.length === 0 ? (
        <div className="empty">{emptyMessage || `No ${title.toLowerCase()} found.`}</div>
      ) : typeof mineContent === 'function' ? (
        mineContent(filtered)
      ) : (
        mineContent
      )}
    </ResourcePageStyled>
  );
}
